import { AppConfigurationClient } from "@azure/app-configuration";

const connectionString = process.env.REACT_APP_APP_CONFIG_CONNECTION_STRING;

const appConfigurationClient = connectionString ? new AppConfigurationClient(connectionString) : null;

export default appConfigurationClient; 